<!--suppress CheckEmptyScriptTag -->
<template>
  <layout>

    <sticky-post-menu 
      :header="section.name"
      @onclick="onSaveClick"/>

    <form
      v-if="section.key !== 'home'"
      ref="form"
      @submit.prevent="submit">
      <fields
        :fields="fields.all()"
        :model="model"
        :errors="errors"
        layout="vertical" />
    </form>
  </layout>
</template>

<script>
  import { FormMixin } from 'stylemix-base';
  import { mapState } from 'vuex';
  import isPlainObject from 'lodash-es/isPlainObject';
  import find from 'lodash-es/find';
  import Layout from '../layouts/Default.vue';
  import StickyPostMenu from '../components/StickyPostMenu.vue';
  import Swal from "sweetalert2";

  export default {
    name: 'SettingsIndex',

    components: {
      Layout,
      StickyPostMenu
    },

    mixins: [FormMixin],

    data: () => ({
      model: {},
      errorsText: {},
    }),

    computed: {
      ...mapState('settings', {
        sections: state => state.sections
      }),

      section() {
        const current = find(this.sections, { key: this.$route.params.section });

        return current || {};
      },
      errorText(){
        let message = ''
        for(var error in this.errorsText){
          message += this.errorsText[error].join("\r\n")
        }
        return message
      }
    },

    watch: {

      /**
       * @param {string} newSection
       * new value of $route.params.section
       * e.g. "general", "payment" etc.
       */
      ['$route.params.section'](newSection) {
        // clear old form fields
        this.setFields([]);
        this.loadForm();
      },

    },

    mounted() {
      this.loadForm();
    },

    methods: {
      loadForm() {
        this.withUiBlocker(
          this.$http.get(`admin-settings/sections/${this.$route.params.section}`)
            .then(response => {
              this.model = isPlainObject(response.data.data) ? response.data.data : {};
              this.setFields(response.data.fields);
            }),
        );
      },

      submit() {
        this.withUiBlocker(
          this.$http.post(`admin-settings/sections/${this.$route.params.section}`, this.model)
            .then(() => {
              this.$toast.success('Setting saved successfully!');
            }).catch(error => {
              this.errorsText = error.response.data.errors
              Swal.fire(
                {
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  title: error.response.data.message,
                  text: this.errorText,
                  type: 'error',
                  timer: 5000
                },
              )
            }),
          this.$refs.form
        );
      },

      onSaveClick() {
        this.submit();
      }
    }
  }
</script>
